import styled from "styled-components";

import { Link } from "react-router-dom";

import { theme } from "../../../../styles/theme";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  @media screen and (max-width: 479px) {
    width: 100%;
    .col-4 {
      width: 100% !important;
    }
  }
`;
export const CardContent = styled.div`
  width: 90%;
  height: 85%;
  background-color: ${theme.colors.darkBlue};
  border-radius: 20px;
  padding: 30px 0px 30px 60px;
  margin: 0 auto;

  label {
    width: 100% !important;
  }

  .button-box {
    display: flex;
    justify-content: center;
    padding-right: 60px;

    button {
      width: 25%;
    }

    button:first-of-type {
      margin-right: 10px;
    }

    button:last-of-type {
      margin-left: 10px;
    }
  }

  form {
    overflow: auto;
    height: 100%;
    padding-bottom: 200px;

    & .row-container {
      padding-right: 60px;
    }

    ::-webkit-scrollbar {
      width: 8px !important;
    }

    ::-webkit-scrollbar-track {
      background-color: ${theme.colors.blue800} !important;
    }

    ::-webkit-scrollbar-thumb {
      background: ${theme.colors.gray800} !important;
      border-radius: 0 !important;
    }
  }

  @media screen and (max-width: 768px) {
    padding: 0 !important;
    width: 100%;
    background-color: transparent;
    height: 90%;

    #form-factory {
      padding-bottom: 20px;
    }

    .row-container {
      padding-right: 10px !important;
    }

    .container-field {
      input:not([type="radio"]) {
        width: 100% !important;
      }
    }

    label {
      font-size: 14px;

      span {
        font-size: 16px;
        width: 35px;
        height: 35px;
        min-width: 35px;
        min-height: 35px;
      }
    }

    .button-box {
      button[type="button"] {
        background-color: transparent;
      }
    }

    .container-form {
      margin-bottom: 0;
      width: 100% !important;
    }

    .p-dropdown {
      background-color: ${theme.colors.blue900} !important;
    }

    .p-dropdown-items {
      background-color: ${theme.colors.blue900} !important;
    }
  }
`;

type StatusProp = {
  color: string;
};
export const TitleContainer = styled.div`
  display: flex;
  margin-bottom: 15px;
`;
export const ContainerButton = styled.div``;
export const ContainerButtonActions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  button {
    margin-left: 10px;
  }
`;

export const ExportButtonComponentStyled = styled.button`
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
  align-items: center;
  padding: 13px 45px;
  font-family: "poppins";
  border: 1px solid ${theme.colors.primary};
  border-radius: 100px;
  font-size: 0.8rem;
  margin-left: 15px;
  line-height: 1.6;
  &:hover {
    opacity: 0.7;
  }
  svg {
    margin-bottom: 2px;
    margin-right: 10px;
  }
`;

type ProgressProps = {
  value?: number | 0;
  max?: number | 100;
};
export const ProgressStyled = styled.progress`
  height: 12px;
  border: 1px solid ${theme.colors.primary};
  position: relative;
  border-radius: 15px;
  overflow: hidden;
  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
  }

  &::before {
    width: 100%;
    background: #fff;
  }

  &::after {
    width: ${(e: ProgressProps) =>
      e?.value ? (e?.value * 100) / (e?.max || 0) : 0}%;
    border-radius: 15px;
    background: ${theme.colors.primary};
  }
`;
export const FilterStyled = styled.div`
  position: relative;
  width: 100%;
  min-width: 250px;
  padding: 0px 15px 15px 15px;
  display: flex;
  flex-direction: column;
`;
export const FieldCheckbox = styled.label`
  font-weight: 400;
  color: ${theme.colors.black};
  font-size: 0.8rem;
  font-family: "poppins";
  display: flex;
  align-items: center;
  margin-bottom: 5px;
`;
export const CheckboxStyled = styled.input`
  font-weight: 400;
  color: ${theme.colors.black};
  font-size: 1.5rem;
  font-family: "poppins";
  margin-right: 8px;
  accent-color: #01ac1c;
`;
export const ButtonStyled = styled.button`
  margin: 5px 0;
  height: 1px;
  width: 100%;
  background-color: ${theme.colors.lightGray};
  padding: 20px;
  width: 100%;
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  margin-top: 30px;
`;
export const SperatorStyled = styled.span`
  margin: 5px 0;
  height: 1px;
  width: 100%;
  padding: 0 5px;
  background-color: ${theme.colors.lightGray};
`;
export const TitleStyledFilter = styled.h5`
  display: flex;
  font-weight: 400;
  color: ${theme.colors.black};
  font-size: 0.8rem;
  font-family: "poppins";
  margin-bottom: 10px;
  margin-top: 10px;
`;
export const DateContainer = styled.div`
  display: flex;
`;
export const DateStyled = styled.input`
  margin-right: 10px;
  border: 1px solid ${theme.colors.primary};
  color: ${theme.colors.black};
  max-width: 100px;
  border-radius: 6px;
  padding: 10px 5px;
  font-size: 0.8rem;
  font-family: "poppins";
`;
export const LabelStyled = styled.label`
  display: flex;
  flex-direction: column;
  font-size: 0.8rem;
  font-family: "poppins";
  font-weight: 400;
  color: ${theme.colors.primary};
`;
export const TitleStyled = styled.h1`
  color: ${theme.colors.black};
  font-size: 2rem;
  padding: 0 15px;
  font-weight: 500;
`;
export const StatusStyled = styled.li`
  color: ${(p: StatusProp) => p.color};
`;
export const RatingStyled = styled.div`
  width: 100%;
  display: flex;
  p {
    margin-left: 5px;
    margin-bottom: 0;
  }
  align-items: center;
`;

export const RowStyled = styled.div`
  width: 100%;
  display: flex;
`;
export const RowTitleStyled = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-right: 15px;
  margin-bottom: 15px;
`;
export const SplitStyled = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 20px;
  height: calc(50% - 10px);
`;
export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 70%;
`;
type ColProp = {
  width: number;
};

export const ColStyled = styled.div`
  margin: 10px;
  padding: 0;
  width: ${(p: ColProp) => p.width}%;
`;

export const Title = styled.h1`
  margin: 10px;
  padding: 0;
  font-family: "palanquin";
  font-weight: 500;
  font-size: 2rem;
`;
export const ButtonComponentStyled = styled(Link)`
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
  align-items: center;
  padding: 15px 45px;
  border-radius: 100px;
  font-size: 0.8rem;
  line-height: 1.6;
  &:hover {
    color: ${theme.colors.white};
    opacity: 0.7;
  }
  svg {
    margin-bottom: 2px;
    margin-right: 5px;
  }
`;

export const CustomGrid = styled.div`
  .title-grid {
    padding: 10px 0px 0px 20px;
    color: #fff;
    font-weight: 600;
    font-size: 16px;
  }
  background-color: #0c7488;
  border-radius: 20px;
  .data-grid {
    .row-grid .cel-grid:nth-of-type(1):before {
      /* background: #000; */
      border-right: 1px solid #000;
      content: "";
      height: 100%;
      position: absolute;
      right: 0;
    }
    .cel-grid {
      position: relative;
    }
    margin: 10px 0;
    border-radius: 0;
    .header-grid {
      padding: 0;
    }
    .paginate {
      background-color: #0d7488;
      border-radius: 0 0px 20px 20px;
      ul {
        margin: 0;
        li a {
          background-color: #f32642;
          color: #fff;
        }
        li.selected a {
          background: #fff;
          color: #000;
          border-radius: 6px;
        }
      }
    }
  }
`;
